"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { NavbarAuth } from "@/components/auth/navbar-auth";
import { useAuth } from "@/providers/auth-provider";

/**
 * Right-slot actions for the marketing navbar.
 *
 * Logged out → the acquisition CTAs (Log In + Start Writing for Free).
 * Logged in  → the shared NavbarAuth widget (avatar + coins + bell), so an
 *              author who lands on a marketing page (/writers, /about, …) sees
 *              their signed-in state instead of being pitched to sign up.
 *
 * While auth resolves we reserve an avatar-sized slot so the CTAs don't flash
 * in and then get swapped out for the avatar.
 */
export function MarketingNavbarActions() {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div
                aria-hidden="true"
                className="size-8 animate-pulse rounded-full bg-muted"
            />
        );
    }

    if (user) {
        return <NavbarAuth avatarLink="" settingsHref="/account/settings" />;
    }

    return (
        <>
            {/* Log In collapses into the hamburger on mobile */}
            <Button variant="ghost" className="hidden text-sm md:inline-flex" asChild>
                <Link href="/login">Log In</Link>
            </Button>
            <Button
                className="bg-accent text-white hover:bg-accent/90 text-sm font-semibold shadow-lg shadow-accent/30 rounded-full px-6"
                asChild
            >
                <Link href="/signup/writer">Start Writing for Free</Link>
            </Button>
        </>
    );
}
